// Platform operator screens, behind one door.
//
// Two items that only Paul can see, sitting permanently in a rail
// shared with the firm's daily work. They belong to running the
// platform rather than running a case, and grouping them says so.

import React, { useState } from "react";
import { C } from "../constants.js";
import { I } from "../icons.jsx";
import { PlatformFirmsPage } from "./PlatformFirmsPage.jsx";
import { PlatformDirectoryPage } from "./PlatformDirectoryPage.jsx";

const SECTIONS = [
  { id: "firms", label: "Firms",
    blurb: "Every firm on the platform, and the state of each one's setup." },
  { id: "directory", label: "Universal Directory",
    blurb: "Providers and organisations shared across all firms." },
];

export function PlatformHubPage({ authStatus, showNotification,
                                 initialSection = null }) {
  const [section, setSection] = useState(initialSection);

  if (section) {
    return React.createElement("div", null,
      React.createElement("div", {
        style: { padding: "20px 40px 0", maxWidth: "1280px" },
      },
        React.createElement("button", {
          onClick: () => setSection(null),
          style: {
            display: "flex", alignItems: "center", gap: "6px",
            border: "none", background: "none", padding: 0, cursor: "pointer",
            color: C.textMuted, fontSize: "13px",
          },
        }, I.back, "All platform tools"),
      ),
      section === "firms"
        ? React.createElement(PlatformFirmsPage, { authStatus, showNotification })
        : React.createElement(PlatformDirectoryPage, { showNotification }),
    );
  }

  return React.createElement("div",
    { className: "fade-in", style: { padding: "32px 40px", maxWidth: "1000px" } },
    React.createElement("h1", {
      style: {
        fontFamily: "'Playfair Display',serif", fontSize: "28px",
        fontWeight: 600, color: C.navy, marginBottom: "6px",
      },
    }, "Platform"),
    React.createElement("p", {
      style: { fontSize: "15px", color: C.textMuted, marginBottom: "24px" },
    }, "Running the platform, rather than running a case."),

    React.createElement("div", {
      style: {
        display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
        gap: "12px",
      },
    },
      SECTIONS.map(s => React.createElement("button", {
        key: s.id,
        onClick: () => setSection(s.id),
        style: {
          textAlign: "left", cursor: "pointer", background: "#fff",
          border: `1px solid ${C.warmGray}`, borderRadius: "8px",
          padding: "16px 18px",
        },
      },
        React.createElement("div", {
          style: { fontSize: "14px", fontWeight: 600, color: C.navy, marginBottom: "4px" },
        }, s.label),
        React.createElement("div", {
          style: { fontSize: "12px", color: C.textMuted, lineHeight: 1.5 },
        }, s.blurb),
      ))),
  );
}
